<template lang="pug">
v-list.pr-0.pl-2(dark)
  template(v-for="(item, index) in navigationItems")
    template(v-if="item.children && item.children.length")
      v-list-group(
        :key="index"
      )
        template(#activator)
          v-list-item-icon
            v-icon(
              :size="20"
              dark
            ) {{ item.meta.icon }}
          v-list-item-content {{ item.meta.title }}

        template(v-for="children in item.children")
          v-list-item(
            :to="children.to"
            exact
          )
            v-list-item-icon
              v-icon(
                :size="20"
                dark
              ) {{ children.icon }}
            v-list-item-content {{ children.text }}

    template(v-else)
      v-list-item(
        :key="index"
        :to="item.path"
        :class="{ 'v-list-item--active' : isActiveRoute(item) }"
        exact
      )
        v-list-item-icon
          v-icon(
            :size="20"
            dark
          ) {{ item.meta.icon }}
        v-list-item-content
          p: v-badge(
              :value="!!item.meta.new"
              dot
              :offset-x="-2"
              color="redesignWarning"
            ) {{ item.meta.title }}

  template(v-if="!$user.isAuthenticated && !miniDrawer")
    v-list-item(to="/login")
      v-list-item-content Войти
    v-list-item(to="/register")
      v-list-item-content Зарегистрироваться
    v-list-item(to="/instructions")
      v-list-item-content Инструкции
</template>

<script>
import mixinNavigation from './mixinNavigation';
import { flattenArray } from '@/helpers/array';

export default {
  name: 'EvDrawerContentMenu',
  components: {},
  mixins: [mixinNavigation],
  props: {
    miniDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    navigationItems() {
      if (!this.$user.isAuthenticated) {
        return [];
      }

      return flattenArray(this.$user.roles.map((role) => this.navigation[role.name])).map((navItem) => ({
        ...navItem,
        children:
          navItem.meta.children &&
          navItem.meta.children.filter(
            ({ vchtWhitelisted, visibleFor, accessFor, accessArgs }) =>
              (
                !vchtWhitelisted
                && this.$user.hasRoles(visibleFor)
                && (!this.$user.isEventManager || !accessFor?.length || this.$user.hasPermissions(accessFor, ...(accessArgs || [])))
              )
              || (vchtWhitelisted && this.$user.isVchtAllowedOrganization),
          ),
      })).filter(({ meta, children }) => !meta.visibleIfChildren || children?.length);
    },
    currentPath() {
      return this.$route?.path || '';
    },
  },
  watch: {},
  created() {},
  methods: {
    isActiveRoute(route) {
      const { drawerChildren } = this.$route.meta;
      if (drawerChildren?.length) {
        return drawerChildren.find(({ to }) => to === route.path);
      }

      return this.currentPath === route.path;
    },
  },
};
</script>
